import { BaseConnection } from "./connection";

export enum SystemPlaceOfPersonTypes {
  AFFILIATED_MONASTERY = "affiliated_monastery",
  BORN_AT = "born_at",
}

export const SYSTEM_PLACE_OF_PERSON_TYPE_LABELS: Record<
  SystemPlaceOfPersonTypes,
  string
> = {
  [SystemPlaceOfPersonTypes.AFFILIATED_MONASTERY]: "Affiliated Monastery",
  [SystemPlaceOfPersonTypes.BORN_AT]: "Born At",
};

export interface PlaceOfPerson extends BaseConnection {
  system_place_of_person_type: SystemPlaceOfPersonTypes | null;
}

export interface PlaceOfPersonFilters extends BaseConnection {
  system_place_of_person_type:
    | SystemPlaceOfPersonTypes[]
    | SystemPlaceOfPersonTypes
    | null;
}
